import { CacheProps, fetchApi } from '../../../fetch';
import routes from '@routes';

interface MarkAsReadProps extends CacheProps{
  ids: Array<string>;
}

const markAsReadApi = ({ ids, ...rest } : MarkAsReadProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.client.messages-mark-as-read'],
    payload: {
      ids: ids,
    },
    cache: 'no-cache',
    withToken: true,
    ...rest,
  });
};

export default markAsReadApi;
